export default {
  // LSX语言配置
  SKU_is_empty_please_add_SKU_first: "SKU为空，请先添加SKU",
  is_warehouse_address_consistent_with_shop_backend_shipping_address:
    "仓库地址和店铺后台发货地址是否一致",
  is_use_account_to_handle_product_prefix: "是否使用账号处理商品前缀",
  is_default_print_product_barcode_company: "是否默认打印商品条码公司",
  please_select_shop_group: "请选择店铺分组",
  contain_shop: "包含店铺",
  my_pending_task: "我的待办",
  pending_task_category: "待办分类",
  pending_task_title: "待办标题",

  remove_label_available_outbound: "移除可贴单出库",
  set_shop_group: "设置店铺分组",

  please_select_pending_task_category: "请选择待办分类",
  unprocessed: "未处理",
  processed: "已处理",
  todoList: "待办列表",
  pending_task_content: "待办内容",
  refresh: "刷新",
  id_card_number: "身份证号",
  permission_info: "权限信息",
  employee_name: "员工姓名",
  productSKUList: "商品SKU列表",
  secondary_image: "次图",
  do_not_upload_images_repeatedly: "请勿重复上传图片",
  import_modify_product_real_size: "导入修改商品真实尺寸",
  only_used_for_profit_report_calculation: "仅用于利润报表计算。",
  after_setting_costs_the_system_will_automatically_recalculate_associated_data_at_dawn_the_next_day:
    "设置费用后，第二天凌晨会自动重新计算相关联的。",
  refers_to_the_storage_capacity_occupied_by_this_bin_in_the_current_warehouse_measured_in_m3_representing_the_maximum_storable_volume_of_this_bin:
    "指当前仓库内该库位所占库容，采用单位M³衡量，表示该库位可存放的最大容量",
  refers_to_the_actual_storage_capacity_used_by_the_current_warehouse_measured_in_m3_used_capacity_equals_the_volume_of_stored_goods_product_volume_multiply_product_quantity:
    "指当前仓库使用的实际存储库容，采用单位M³衡量，使用库容=已存储货物体积(产品体积*产品数量)",
  supplement_deduction_type: "补扣类型",
  single_outbound_and_print_delivery_note: "单个出库并打印发货单",
  please_select_a_single_data_record: "请选择单条数据",
  please_select_inbound_order: "请选择订单类型为纯入库单的数据",
  listTasksPendingAllocation: "待配货任务列表",
  print_count: "打印次数",
  greater_than: "大于",
  equal: "等于",
  less_than: "小于",
  order_print_log: "订单打印日志",
  auto_generate_allocation_task: "自动生成配货任务",
  condition_setting: "条件设置",
  task_print_log: "任务打印日志",
  Edit_allocation_control: "编辑配货控制",
  max_pending_claim_quantity: "最大待认领数量",
  please_input_max_pending_claim_quantity: "请输入最大待认领数量",
  max_pending_claim_quantity_must_be_greater_than_zero:
    "最大待认领数量必须大于0",
  auto_run_time: "自动运行时间",
  manual_run_time: "手动运行时间",
  manual_run: "手动运行",
  you_can_select_one_or_more_warehouses_freely_the_system_will_only_display_data_of_selected_warehouses_your_selection_will_be_saved_automatically_no_need_to_reset_at_next_login:
    "您可自由选择一个或多个仓库，系统将仅展示所选仓库的数据。您的选择会自动保存，下次登录时无需重复设置。",
  third_party_api_account: "第三方API账号",
  please_enter_third_party_api_account: "请输入第三方API账号",
  third_party_api_account_cannot_be_zero: "第三方API账号不能为0",
  total_storage_capacity_of_location_cannot_exceed_available_storage_capacity:
    "库位库容总和不能超过可用库容",
  check_special_location_capacity: "勾选特殊库位库容",
  checked_data_in_list_will_not_participate_in_automatic_equal_distribution_of_location_capacity_unchecked_data_will_take_the_capacity_of_location_with_the_largest_repetition_quantity_as_the_benchmark_for_equal_distribution_calculation:
    "列表中已勾选的数据，不参与库位库容自动均分；未勾选数据，将以重复数量最多的库位库容作为基准参与均分计算。",
  data_manually_modified_for_location_capacity_will_not_participate_in_location_automatic_equal_distribution_logic:
    "已手动修改过库位库容的数据，不参与库位自动均分逻辑。",
  click_the_special_location_capacity_button_to_automatically_check_list_data_that_meets_special_location_capacity_rules_special_location_capacity_judgment_rule_select_list_data_with_the_least_repetition_quantity_or_no_repetition_as_special_location_capacity:
    "点击【特殊库位库容】按钮，自动勾选符合特殊库位库容规则的列表数据。特殊库位库容判定规则：选取重复数量最少、或无重复的列表数据作为特殊库位库容。",
  location_capacity_total_must_equal_available_capacity:
    "库位库容总和必须等于可用库容",
  logistics_method: "物流方式",
  latest_update_time: "最近更新时间",
  input_custom_size_will_override_fixed_print_size:
    "输入自定义尺寸将会覆盖默认打印尺寸",
  widht_cm: "宽度(cm)",
  height_cm: "高度(cm)",
  Please_input_valid_print_size: "请输入有效的打印尺寸",
  //2026年9月1日新增start
  history_order: "历史订单：",
  orders_within_90_days: "90 天内订单",
  within_days_order: "天内订单",
  //2026年9月1日新增end

  is_print_third_party_shipping_mark_list_box_label:
    "是否打印第三方箱唛/清单/箱标",
  please_select_goods_goods_attribute: "请选择商品货物属性",
  please_upload_goods_image: "请上传商品图片",

  non_dispatched_first_leg_cannot_sync_status: "非“已下发”头程，无法同步状态！",
  batch_delete_storage_location: "批量删除库位",
  confirm_delete_storage_location: "确认删除库位",
  please_input_custom_height: "请填写自定义高度",
  please_input_custom_width: "请填写自定义宽度",
  custom_size_must_be_greater_than_zero: "自定义尺寸必须大于0",
  detail_exceeds_2000_records: "明细超过2千条，入库单数据超长，无法保存",
  please_select_data_with_the_same_task_number: "请选择同一任务编号的数据",
};
